import * as React from "react";
import { Form, Icon, Input, Button, Spin } from "antd";
import { WrappedFormUtils } from "antd/lib/form/Form";

import "./styles.less";

const FormItem = Form.Item;

interface PassedProps extends React.Props<{}> {
  onSubmit: (username: string, password: string) => void;
  isLoggingIn: boolean;
  error: string;
}

interface FormProps extends React.Props<{}> {
  form: WrappedFormUtils;
}

type Props = PassedProps & FormProps;

class LoginFormComponent extends React.Component<Props, {}> {
  private usernameField: Input;

  handleSubmit = e => {
    e.preventDefault();
    this.props.form.validateFields((err, values) => {
      if (!err)
        this.props.onSubmit(values.username, values.password);
    });
  }

  componentDidMount() {
    this.usernameField.focus();
  }

  componentWillReceiveProps(nextProps: Props) {
    if (nextProps.error && nextProps.error !== this.props.error) {
      this.props.form.setFields({
        username: {
          errors: [new Error(nextProps.error)],
        },
      });
    }
  }

  render() {
    const { getFieldDecorator } = this.props.form;

    let form = (
      <Form onSubmit={this.handleSubmit}>
        <FormItem>
          {getFieldDecorator("username", {
            rules: [{ required: true, message: "Please input your username!" }],
          })(
            <Input
              prefix={<Icon type="user" style={{ fontSize: 13 }} />}
              placeholder="Username"
              ref={ref => this.usernameField = ref}
            />
          )}
        </FormItem>
        <FormItem>
          {getFieldDecorator("password", {
            rules: [{ required: true, message: "Please input your Password!" }],
          })(
            <Input
              prefix={<Icon type="lock" style={{ fontSize: 13 }} />}
              type="password"
              placeholder="Password"
            />
          )}
        </FormItem>
        <FormItem className="submit-button-container">
          <Button type="primary" htmlType="submit" className="login-form-button">
            Log in
          </Button>
        </FormItem>
      </Form>
    );

    if (this.props.isLoggingIn) {
      form = (
        <Spin spinning>
          {form}
        </Spin>
      );
    }

    return (
      <div className="login-form">
        {form}
      </div>
    );
  }
}

export const LoginForm = Form.create<any>()(LoginFormComponent);



// WEBPACK FOOTER //
// ./src/components/login-form/index.tsx